import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { mcqSingleChoiceRequest } from '@configs/ai.config';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AIModule } from '../app.urls';
import { AddNewQuestion } from '../shared/addnewquestion';
import { QuestionService } from './question.service';

@Injectable({
  providedIn: 'root'
})
export class AiGenerateService {

  constructor(private http: HttpClient, private questionService: QuestionService) {
    const generateTokenSubscription = this.generateToken(environment.userName, environment.password).subscribe(data => {
      sessionStorage.aiToken = (JSON.stringify(data.jwtToken));
      generateTokenSubscription.unsubscribe();
    })
  }

  generateToken(userName: string, password: string): Observable<any> {
    return this.http.post(AIModule.Authenticate, { userName: userName, password: password });
  }

  //multiple response - AI
  AIGenerateTrueFalseQuestions(data: mcqSingleChoiceRequest): Observable<AiAPIResponse<BooleanQuestion>> {
    return this.http.post<AiAPIResponse<BooleanQuestion>>(AIModule.MultipleChoice, data);
  }

  saveQuestionToSystem(data: AddNewQuestion, itemId: string): Observable<any> {
    return this.questionService.addQuestion(data, itemId);
  }

  singleChoiceMultipleResponse(data: mcqSingleChoiceRequest): Observable<any> {
    return this.http.post(AIModule.McqSingle, data);
  }

  multipleMultipleResponse(data: mcqSingleChoiceRequest): Observable<any> {
    return this.http.post(AIModule.McqMultiple, data);
  }

  booleanMultipleResponse(data: mcqSingleChoiceRequest): Observable<any> {
    return this.http.post(AIModule.McqBoolean, data);
  }

  //freeText
  freeTextAnswer(data: mcqSingleChoiceRequest): Observable<any> {
    return this.http.post(AIModule.FreeText, data);
  }

  //fillInTheBlank
  fillInTheBlank(data: mcqSingleChoiceRequest): Observable<any> {
    return this.http.post(AIModule.FillInBlank, data);
  }
}


export interface AiAPIResponse<T> {
  status: string,
  error: [], data: T,
}

export interface BooleanQuestion {
  question: string
  tags: string[]
  options: string[]
  answer: string
}


// Single response question - Radio
// v1/multiple-choice-item/create

// Single response question - True false
// /v1/multiple-choice-item/boolean/create

// Descriptive text question
// v1/free-text-answer-item/create
